const PREFIX = "AGROEVIDENCE_EAGRI";

export const SET_EAGRI_AUTH = `${PREFIX}/SET_EAGRI_AUTH`;
export const SET_EAGRI_AUTH_SUCCESS = `${PREFIX}/SET_EAGRI_AUTH_SUCCESS`;
export const SET_EAGRI_AUTH_ERROR = `${PREFIX}/SET_EAGRI_AUTH_ERROR`;

export const GET_EAGRI_FARM_NAME = `${PREFIX}/GET_EAGRI_FARM_NAME`;
export const GET_EAGRI_FARM_NAME_SUCCESS = `${PREFIX}/GET_EAGRI_FARM_NAME_SUCCESS`;
export const GET_EAGRI_FARM_NAME_FAILURE = `${PREFIX}/GET_EAGRI_FARM_NAME_FAILURE`;
